module.exports = __webpack_public_path__ + "static/media/tick.eb5a4135.svg";